<template>

  <div v-if="getPermission.ccic.view || getPermission.fsi.view || getPermission.stc.view || getPermission.stcloadlistupdate.view">
    <load-list-form ref="CreateForm" mode="create" :action="onRefresh"/>
    <load-list-form ref="UpdateForm" mode="update" :action="onRefresh"/>
    <load-list-form ref="CopyForm" mode="copy" :action="onRefresh"/>
    <load-list-form ref="DeleteForm" mode="delete" :action="onRefresh"/>
    <load-list-form ref="StatusForm" mode="status" :action="onRefresh"/>
    <urgent-container-list ref="UrgentContainerList" mode="set"/>
    <urgent-container-list ref="ViewUrgentContainerList" mode="view"/>
    <report-layout-form ref="UpdateLayoutForm" mode="update" :onUpdate="doupdate"/>
    <report-layout-form ref="CreateLayoutForm" mode="create" :onUpdate="docreate"/>


     <md-dialog class = "modal" :md-active.sync="isWarning">
      <md-dialog-content class="icons-center">
        <i class="material-icons md-48 md-light ">warning</i>
        <h1 class = "modalTitle" >{{this.modalMessage}}</h1>
      </md-dialog-content>
    </md-dialog>
    <ccic-photo-form ref="CcicPhotoForm" :on-data-refresh="doSearch"/>
    <move-ccic-container-form ref="MoveCcicContainerForm"/>
    <update-ccic-container-status-form ref="UpdateCcicContainerStatusForm"/>



    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>{{gateStatus}}</h3>
        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>Photo Type: {{getPhotoName(p,"INOUT")}}</p>
            <p>Stage info: {{p.photoKey.slice(0, -3)}}</p>
          </view-image>
        </calling-api>
      </md-dialog-content>

      
      <md-dialog-actions>
        <!-- <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"/> -->
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="isPictureModalShowing2">
      <md-dialog-content>
        <h1>Photos</h1>
        <calling-api path="/api/w/ccic/photo/get">
        <div v-if="photos.length === 0">
          <h3>You don't have any photos taken by Drivers</h3>
        </div>
        <div v-else>
          <view-image  :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
           <div v-if="!isLoading" class="space">
              <h3>Type: {{p.title}}</h3>
              <p>File Name: {{getPhotoName(p,"LOAD")}}</p>
            </div>
            <div v-if="isLoading" class="space">
              <p>File Name: {{getPhotoName(p,"LOAD")}}</p>
              <p>{{p.refTimeStamp}}</p>
            </div>            
          </view-image>
        </div>
          
        </calling-api>
      </md-dialog-content>
      <md-dialog-actions>
        <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"
                                  v-if="isLoading"/>
        <md-button class="md-primary" @click="isPictureModalShowing2 = false; isLoading = false;">Close</md-button>      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="isPictureModalShowing3">
      <md-dialog-content>
        <h3>{{gateStatus}}</h3>
        <!--
        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>Photo Type: {{getPhotoName(p,"INOUT")}}</p>
            <p>Stage info: {{p.photoKey.slice(0, -3)}}</p>
          </view-image>
        </calling-api>
      -->
          <view-image :key="signURL" :src="signURL">
          </view-image>

      </md-dialog-content>

      
      <md-dialog-actions>
        <!-- <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"/> -->
        <md-button class="md-primary" @click="isPictureModalShowing3 = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
            <div class = "inputBoxLoadList">
              
              <auto-complete-master-data-select
                          label="Sales Office"
                          display-type="idOnly"
                          :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_SALEOFFICE')"
                          :init-value-id="searchRequest.salesOffice"
                          :on-item-changed="handleOfficeChanged">
              </auto-complete-master-data-select>




              <!-- <md-field>
                <label>Sales Office</label>
                <md-input :disabled="true" v-model="searchRequest.salesOffice" @keyup.enter="doSearch"/>
              </md-field> -->
            </div>
            <div class = "inputBoxLoadList" > 
              <auto-complete-master-data-multiple-select
                  label="Status"
                  :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS')"
                  v-model="searchRequest.loadStatus"
              />
            </div>

            <div class = "inputBoxLoadList">
              <md-field>
                <label>Del. Order</label>
                <md-input v-model="searchRequest.gstOrder" @keyup.enter="doSearch"/>
              </md-field>
            </div>

            
            <!-- <div class = "inputBox" v-if="canSearchByTeam">
              <auto-complete-master-data-multiple-select
                  label="GST Team"
                  v-model="searchRequest.teams"
                  :prepared-options="getCcicTeamSearchOptions"
              />
            </div> -->
            <!-- <div class = "inputBox" v-if="canSearchByUsers">
              <auto-complete-master-data-multiple-select
                  :prepared-options="getCcicUserSearchOptions"
                  label="Users"
                  v-model="searchRequest.users">
              </auto-complete-master-data-multiple-select>
            </div> -->
          </div>
          <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">
            <div class = "inputBoxLoadList" >
              <md-field>
                <label>Chassis #</label>
                <md-input v-model="searchRequest.chassisNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div class = "inputBoxLoadList" >
              <datepicker v-model="searchRequest.moveInDate.startDate">
                <label>Move in date</label>
              </datepicker>
            </div>
            

            <div class = "inputBoxLoadList" >
              <datepicker v-model="searchRequest.createDate.startDate">
                <label>Create date</label>
              </datepicker>
            </div>

            <div class="inputBoxLoadList">
              <auto-complete-master-data-select
                        group="REC_WINDOW"
                        label="Rev. Windows"
                        :preparedOptions="loaded_recwin"
                        :init-value="searchRequest.receivingWindows"
                        :on-item-changed="handleWindowsChanged"
                    >
                    </auto-complete-master-data-select>

            </div>
            

          </div>
          <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">
            <div class = "inputBoxLoadList" >
              <md-field>
                <label>Container #</label>
                <md-input v-model="searchRequest.containerNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div class = "inputBoxLoadList" >
              <datepicker v-model="searchRequest.moveInDate.endDate">
                <label>To</label>
              </datepicker>
            </div>
            

            <div class = "inputBoxLoadList" >
              <datepicker v-model="searchRequest.createDate.endDate">
                <label>To</label>
              </datepicker>
            </div>


            




          </div>
          <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">
            <div class = "inputBoxLoadList">
              <md-field>
                <label>Booking #</label>
                <md-input v-model="searchRequest.bookingNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div class = "inputBoxLoadList">
              <md-field>
                <label>Customer Order</label>
                <md-input v-model="searchRequest.customerOrder" @keyup.enter="doSearch"/>
              </md-field>

            </div>

            <div class = "inputBoxLoadList" >
              <datepicker v-model="searchRequest.chzEndDate.startDate">
                <label>Ingate date</label>
              </datepicker>
            </div>

            


          </div>
          <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
           

            <div class = "inputBoxLoadList" >
              <auto-complete-master-data-select id="searchcarrier"
                       label="Carrier"
                       display-type="idOnly"
                       :prepared-options="this.getMasterDataAsSelectOptionByGroup('STC_CARRIER')"
                       :init-value-id="searchRequest.carrier"
                       :on-item-changed="handleCarrierChanged">
                   </auto-complete-master-data-select>
              <!--
              <md-field>
                <label>Used Day</label>
                <md-input v-model="searchRequest.usedDay" @keyup.enter="doSearch"/>
              </md-field>
            -->
               <!-- <master-data-select label="Day In Yard" group="DAYS_OF_USED" v-model="searchRequest.inYardDate"/> -->
            </div>




            <div class = "inputBoxLoadList">
              <md-field>
                <label>Location</label>
                <md-input v-model="searchRequest.locationNumber" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            
            <div class = "inputBoxLoadList" >
              <datepicker v-model="searchRequest.chzEndDate.endDate">
                <label>To</label>
              </datepicker>
            </div>

          </div>

          <div>
             <md-checkbox class="checkbox-ccic" v-model="searchRequest.isCCICSearch">For CCIC</md-checkbox>
             <md-checkbox class="checkbox-ccic" v-model="mismatchOnly">Mis-Match Only</md-checkbox>
          </div>
          <div class="result-included-outter-div-btn1">
            <div class="result-included-inner-div-btn1">
              <!--<md-radio v-model="selectInboundLayout" value="inbound_layout_default"  @change="onSelectreport" >Default</md-radio>-->
              <!--<md-radio v-model="selectInboundLayout" value="inbound_layout_1"  @change="onSelectreport" >1</md-radio>-->
              <!--<md-radio v-model="selectInboundLayout" value="inbound_layout_2"  @change="onSelectreport" >2</md-radio>-->
              <div class = "inputBox layout-input">
                 <auto-complete-select
                        :label="layout_type"
                        :value="selectedLayout"
                        :on-item-changed="handleLayoutChanged"
                        :options="userLayoutNameList"
                    >   
                 </auto-complete-select>
              </div>
              <div class="layout-div">
                  <md-button class="custButton md-raised icon1 align-right" @click="createLayout" >Create</md-button>
                  <md-button class="custButton md-raised icon1 align-right" @click="updateLayout" >Update</md-button> 
                  <md-button class="md-raised custButton icon1 align-right" @click="doReloadLayout">Reload</md-button>
                  <md-button class="custButton md-raised icon1 align-right" @click="loadLayout" >Load</md-button>
              </div>
            </div>
          </div> 



          <div v-if="getPermission.ccic.edit || getPermission.fsi.edit || getPermission.stc.edit || getPermission.stcloadlistupdate.view" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/gst/loadlist', '/api/w/excel/generate','/api/w/ccic/photo/get','/api/w/gst/upload/loadlist','/api/w/ccic/photo/getInOutGate','/api/w/gst/upload/loadlistpartial','/api/w/stc/updateUrgentContainer']">
              <callingApiCenter path="/api/w/gst/loadlistpartial" :not-display-error="true" >
               <!--<md-button class="md-raised" :disabled="!canNew" @click="doNew">New</md-button>-->
               <md-button class="md-raised custButton " @click="toggleCreate" :disabled="(this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view"><span class="icons-center material-icons">create</span>New</md-button>
               <md-button class="md-raised custButton" >
                 <md-menu  class="md-raised" md-size="big">
                  <md-button class=" custMenuButton" md-menu-trigger :disabled="(this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view"><span class="icons-center material-icons">create</span>Upload</md-button>
                  <md-menu-content>
                    <md-menu-item @click="downloadUploadTempalte">Download Template</md-menu-item>
                    <md-menu-item @click="toggleUpload">Upload</md-menu-item>
                  </md-menu-content>
                </md-menu>
               </md-button>
               
               <div class="dropdown">
                   <md-button class="md-raised custButton " @click="doDropDown('edit')" :disabled="(this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view">Edit...  <span class="icons-center material-icons">add</span></md-button>                
               </div> 
<!--
               <md-button class="md-raised custButton"  :disabled="!canChange || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view" @click="doEdit"><span class="icons-center material-icons">update</span>Change</md-button>
               <md-button class="md-raised custButton"  :disabled="!canEdit || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view" @click="doCopy"><span class="icons-center material-icons">file_copy</span>Copy</md-button>
-->               
               <!-- <md-button class="md-raised custButton"  :disabled="!canStatus" @click="doStatus"><span class="icons-center material-icons">update</span>Status</md-button> -->
<!--               
               <md-button class="md-raised custButton"  :disabled="!canDelete || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view" @click="doDelete"><span class="icons-center material-icons">delete</span>Delete</md-button>
-->               
               <md-button class="md-raised custButton"  :disabled="!canVoid || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlyforerl.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view" @click="doVoid"><span class="icons-center material-icons">delete</span>Void</md-button>
               
               <div class="dropdown" v-if="getPermission.stc.edit || getPermission.acnit.view">
                      <md-button :disabled="!this.getPermission.stcClerk.view" class="md-raised custButton " @click="doDropDown('urgent')">Urgent...  <span class="icons-center material-icons">add</span></md-button>
                      <!--
                      <div id="dropdown" class="dropdown-content" v-if="showDropDown">
                         <a href="#" id="dd_li" @click="doCreateUrgentCntr" disabled="!canEdit">Create</a>
                         <a href="#" @click="doViewUrgentCntr">View</a>
                      </div> 
                    -->
                </div>
                <!--
                <div id="dropdown" class="dropdown-content" v-if="showDropDown && (getPermission.stc.edit || getPermission.acnit.veiw)">
                         <a href="#" id="dd_li" @click="doSetUrgentCntr" disabled="!canEdit">Set Cntr List</a>
                         <a href="#" @click="doViewUrgentCntr">View Cntr List</a>
                </div> 
              --> 
                <md-button v-if="getPermission.fsi.edit && !getPermission.acnit.view" @click="doViewUrgentCntr" class="md-raised custButton"><span class="icons-center material-icons">add_alarm</span>Urgent</md-button> 


                <md-button id = "searchTag"  @click="doSearch" class=" custButton btn-search-ccic-container btn-search-loadlist-container md-primary md-raised">Search</md-button>
                <md-button  @click="clearSearch" class="md-raised custButton">Clear</md-button>

                <div class="dropdown">
                    <md-button class="md-raised custButton " @click="doDropDown('download')">Download..<span class="icons-center material-icons">add</span></md-button>                  
                </div> 
                <!-- 
                <md-button v-if="filteredRows.length > 0" class="md-raised custButton" @click="doDownloadExcel"><span class="icons-center material-icons">cloud_download</span>Download</md-button>
                <md-button v-if="filteredRows.length > 0" class="md-raised custButton" @click="doDownloadChassisreport"><span class="icons-center material-icons">cloud_download</span>Chassis Rep</md-button>
                <md-button v-if="filteredRows.length > 0" class="md-raised custButton" @click="doPhotos"><span class="icons-center material-icons">cloud_download</span>Loading Pic</md-button>
                -->
                    <input class="custSearchBar1" type="text"
                       placeholder="Searching Term"
                       v-model="filter"/>
            
            <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
              <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
              <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
            </md-button>
              </callingApiCenter>
            </callingApiCenter>

            <b-notification class = "notifySize"
                  type="is-success"
                  v-model="notifyActive"
                  aria-close-label="Close notification">
                  {{notification}}
                </b-notification>

          </div>
        </div>
         <input type="file" class="md-hide" id="upload-load-list" accept=".xls,.xlsx" @change="handleUploadApplicationFileSelected"/>
      </md-card-content>
    </md-card>
    <pagination-new :items="filteredRows" :totalItems="itemTotalCount">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                 <table id="headertable">
                   <thead>
                     <tr>
                      <th class="header-cell w2 fix"></th>
                      <th v-for="(value, key) in loaded_user_layout" :key="key"
                          class="header-cell center" 
                          v-bind:class="{ w2: value.colWidth == '2', w3: value.colWidth == '3', w4: value.colWidth == '4', 
                                          w5: value.colWidth == '5', w7: value.colWidth == '7', w8: value.colWidth == '8',
                                          w10: value.colWidth == '10', w15: value.colWidth == '15'}"
                          v-on:click="sortFunction(value.colDataElement)"
                      >
                       {{ value.colHeaderText }}
                      </th>  

                    </tr>
                  </thead>
                </table>
                
              </div>
              <div class="table-body " @scroll="handleScroll">
                 <table id="bodytable">
                   <tbody>
                      <tr :key="item.seqNo" class="" v-for="item in pageItems">
                        <td class="body-cell w2">
                           <md-checkbox v-model="item.selected">
                             <span></span>
                           </md-checkbox>
                        </td>

                        <td v-for="(value,key) in loaded_user_layout" :key="key"
                               class="body-cell excelBox" 
                               v-bind:class="{ w2: value.colWidth == '2', w3: value.colWidth == '3', w4: value.colWidth == '4', 
                                             w5: value.colWidth == '5', w7: value.colWidth == '7', w8: value.colWidth == '8',
                                             w10: value.colWidth == '10', w15: value.colWidth == '15', mismatch: value.colDataElement == 'bookingNo' && item.mismatchBooking == true,
                                             warnErr: value.colDataElement == 'ctnrUsedDay' && overPeriod(item)}"
                        >
                           <template v-if="value.colDataType == 'DATE' || value.colDataType=='TIME'">
                              <template v-if="value.colDataType == 'DATE'">
                                 {{ item[value.colDataElement] | date }}
                              </template>
                              <template v-if="value.colDataType == 'TIME'">
                                 {{ item[value.colDataElement] | time }}  
                              </template>
                           </template>
                           <template v-if="value.colDataElement == 'usedHour'">
                              {{ getChassisUsedHour(item) }}                              
                           </template>
                           <template v-if="value.colDataElement == 'yard'">
                              <div class="spaceLine">{{ item[value.colDataElement] }}</div>
                           </template> 
                           <template v-if="value.colDataElement == 'mismatchBooking'">
                              <md-checkbox v-model="item[value.colDataElement]" disabled></md-checkbox>
                           </template>
                           <template v-if="value.colDataElement == 'photoCount' || value.colDataElement == 'inGatePhotoCount' || value.colDataElement == 'outGatePhotoCount' || value.colDataElement == 'chassisplusPhotoCount'">
                              <template v-if="item[value.colDataElement] > 0">
                                  <a href="" @click.prevent="toggleItemPhoto(item, value.colDataType)">{{ item[value.colDataElement] }} photos</a>
                              </template>
                           </template>
                           <template v-if="value.colDataElement == 'driverPayConfirmSignImage' || value.colDataElement == 'driverTaskConfirmSignImage'">
                              <template v-if="item[value.colDataElement] != null && item[value.colDataElement] != ''">
                                  <a href="" @click.prevent="toggleItemPhoto(item, value.colDataType)">1</a>
                              </template> 
                           </template>
                           <template v-if="value.colDataElement == 'stcDriverTasksConfirmed' || value.colDataElement == 'stcDriverTaskPayConfirmed'">
                              <md-checkbox v-model="item[value.colDataElement]" disabled></md-checkbox>
                           </template>
                           <template v-if="value.colDataElement == 'ownChassis'">
                              <template v-if="item[value.colDataElement] == 'YES'">
                                  YES
                              </template>
                              <template v-else>
                                  NO
                              </template>
                           </template>
                           <template v-if="value.colDataElement == 'containerNo' || value.colDataElement == 'chassisNo'">
                              <span @click="toggleContainerCopy(item[value.colDataElement])" v-bind:class="{ spaceLine: value.colDataElement == 'chassisNo'}">
                                  {{ item[value.colDataElement] }}
                              </span>
                              <template v-if="containerCopy == true">
                                  <span class="popuptext" id="myPopup" v-if="value.colDataElement == 'containerNo'">
                                      Container No copied
                                  </span>
                                  <span class="popuptext" id="myPopup" v-if="value.colDataElement == 'chassisNo'">
                                      Chassis No copied
                                  </span>
                              </template>
                           </template>
                           <template v-if="value.colDataElement == 'urgentContainer'">
                              <template v-if="item[value.colDataElement] == true">
                                 X
                              </template>
                           </template>
                           <template v-if="value.colDataType != 'DATE' && value.colDataType != 'TIME' && !excludedColEles.includes(value.colDataElement)">
                              {{ item[value.colDataElement] }}
                           </template>
                        </td>   
                     </tr>
                  </tbody>
                </table>
                
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination-new>
    <div id="dropdown" class="dropdown-content" v-if="showUrgentDropDown && (getPermission.stc.edit || getPermission.acnit.veiw)">
                         <a href="#" id="dd_li" @click="doSetUrgentCntr" disabled="!canEdit">Set Cntr List</a>
                         <a href="#" @click="doViewUrgentCntr">View Cntr List</a>
    </div> 
    <div id="dropdown" class="dropdown-content-edit" v-if="showEditDropDown">
         <a href="#" id="dd_li" @click="doEdit" :disabled="!canChange || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view">Change</a> 
         <a href="#" @click="doCopy" :disabled="!canEdit || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view">Copy</a>
         <a href="#" @click="doDelete" :disabled="!canDelete || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view">Delete</a>
    </div>
    <div id="dropdown" class="dropdown-content-download" v-if="showDownloadDropDown" :disabled="filteredRows.length <= 0">
         <a href="#" id="dd_li" @click="doDownloadExcel" >Download</a> 
         <a href="#" @click="doDownloadChassisreport">Chassis Rep</a>
         <a href="#" @click="doPhotos">Loading Pic</a>
    </div>
  </div>
</template>

<style scoped>



.popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.spaceLine {
  margin-bottom: 10px;
}




.popuptext {
  visibility: show;
  width: 160px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  left: 50%;
  margin-left: -80px;
}

.excelBox {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
  
}

.excelBoxLeft {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.inputBoxLoadList {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 2px;
}

.inputBoxLoadList:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 2px;
    background-color: #e0eff7;
      
}

.selected {
     background: #726a95;
}

.tableW {
    height: 40px;
}

.center {
    text-align: center;
}

tr:hover {
    background: #c8e6f5;
}

.headerCenter {
    text-align: center;
}


.modal {
     background-color: #29303b;
      border-radius: 5px;
}
.modalTitle {
    font-weight: normal;
    font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;
    margin-bottom: 0.5rem;
    line-height: 1.6;
}

.md-menu {
  padding: 0;
  padding: 0;

}

.custButton {
    margin: 10px;
    width: 80px;
    height: 36px;
    line-height:20px;
    font-size: 0.7rem;
}

.custMenuButton {
    width: 110px;
    height: 40px;
    font-size: 0.7rem;
    
}

.custSearchBar{
    margin: 10px;
    width: 200px;
    width: 300px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}

.custSearchBar1{
    margin: 10px;
    /*width: 200px;*/
    width: 180px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}


.custButtonRight {
    margin: 10px;
    width: 100px;
    height: 40px;
    float : right;
}
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  /*display: none;*/
  position: absolute;
  /*position: relative;*/
  /*position: relative;*/
  /*position: fixed;*/
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  margin-top: -39px;
  margin-left: 450px;
  z-index: 1000;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;

}

.dropdown-content-edit {
  /*display: none;*/
  position: absolute;
  /*position: relative;*/
  /*position: relative;*/
  /*position: fixed;*/
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  margin-top: -39px;
  margin-left: 250px;
  z-index: 1000;
}

/* Links inside the dropdown */
.dropdown-content-edit a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;

}

.dropdown-content-download {
  /*display: none;*/
  position: absolute;
  /*position: relative;*/
  /*position: relative;*/
  /*position: fixed;*/
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  margin-top: -39px;
  margin-left: 800px;
  z-index: 1000;
}

/* Links inside the dropdown */
.dropdown-content-download a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;

}


/* Change color of dropdown links on hover */
.dropdown-content a:hover {background-color: #ddd;}
.dropdown-content-download a:hover {background-color: #ddd;}
.dropdown-content-edit a:hover {background-color: #ddd;}

.checkbox-ccic {
  margin-left: 39px;
  margin-top: 10px;
}

/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
.show {display:block;}
.setzindex {z-index:3;}
.mismatch { color: red;}
.warnErr { color: red;}

.result-included-outter-div-btn1 {
    border: 1px solid #D0D0D0;
    background-color: rgba(161, 103, 103, 0.3);
    border-radius: 5px;
    width: 760px;
    padding: 0px;
    height: 70px;
    margin-top: -30px;
    margin-bottom: 5px;
    margin-left: 460px;
}
.result-included-inner-div-btn1 {
    margin-left: 5px;
    margin-top: 10px;
    margin-bottom: 0px;
}

.align-right {
    float: right;
}
.layout-input {
    width: 280px;
    margin-top: -5px;
}
.layout-div {
    margin-top:-60px; 
    margin-left: 80px;
    padding: 2px;
}

.custButton {
margin: 5px;
width: 120px;
height: 40px;
line-height:40px;
font-size: 0.8rem;

}

.inputBox {
border: 1px solid #cacbcc;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 5px 5px 5px 5px;
margin-top: 5px;
}

.inputBox:hover {

border: 2px solid #448aff;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 6px 6px 6px 6px;
margin-top: 5px;
background-color: #e0eff7;
  
}

</style>

<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import sort from 'fast-sort';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  //import api from "../api";
  import { newAPIPost } from '../api/index.js';
  import UpdateCcicContainerStatusForm from "../components/UpdateCcicContainerStatusForm.vue";
  import CcicPhotoForm from "../components/CcicPhotoForm.vue";
  import MoveCcicContainerForm from "../components/MoveCcicContainerForm.vue";
  import parseXls from "../utils/parseXls";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import UrgentContainerList from "../components/UrgentContainerList.vue";
  import LoadListForm from '../components/LoadListForm.vue';
  import moment from 'moment';
  import ReportLayoutForm from "../components/ReportLayoutForm.vue";  

  const containerStats = [
    {
      id: 'APPROVE',
      name: 'APPROVE',
    },
    {
      id: 'REJECT',
      name: 'REJECT',
    },
    {
      id: 'UNLOAD',
      name: 'UNLOAD',
    },
    {
      id: 'UNLOAD&REJECT',
      name: 'UNLOAD&REJECT',
    },

    {
      id: 'PUNCH',
      name: 'PUNCH',
    },

    {
      id: 'PARTIAL_UNLOAD',
      name: 'PARTIAL UNLOAD',
    },

    {
      id: 'NA',
      name: 'NA',
    },
  ];

  

  const uploadCols = [
    'salesOffice',
    'containerNo',
    'chassisNo',
    'source',
    'receivingWindows',
    'ctnrType',
    'moveInDate',
    'moveInTime',
    'moveInBy',
    'carrier',
    'ownChassis',
    'chassisVendor',
    'loadStatus',
    'yard',
    'CustomerNumber',
    'poolContract',
  ];

  const getInitSearch = () => ({
    moveInDate: {
      startDate: moment().subtract(1,'months').startOf('d').toDate(),
      endDate: moment().endOf('d').toDate(),
    },

    chzEndDate: {
      startDate: null,
      endDate: null,
    },

    createDate:{
      startDate: null,
      endDate: null,
    },
    
    users: [],
    teams: [],
    seqNo:null,
    salesOffice: null,
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    yard: null,
    locationNumber: null,
    usedDay:null,
    inYardDate: null,
    customerOrder: null,
    gstOrder: null,
    bookingNo: null,
    orderType: null,
    locCode:null,
    locName: null,
    inGateDate: null,
    InGatePhoto: null,
    scac: null,
    poolContract: null,
    ownChassis:false,
    chassisVendor: null, 
    loadStatus: ['EPT','LD'],
    selected: false,
    isCCICSearch: false,
    usersInTeam: [],
    receivingWindows: null,
  });

  const reportLayoutElements = () => ({
    orderIndex: null,
    colHeaderText: null,
    colDataElement: null,
    colDataType: null,
    colWidth: null,
  });
  const getInitialLayoutSearchRequest = () => ({
    office: null,
    layoutOwner: null,
    layoutName: null,
    reportModule: null,
    colIndex: null,
    onlyActive: null,
    layoutnamelist: null,
  });


  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      dialog: {
        isShowing: false,
      },
      items: [],
      isPictureModalShowing: false,
      isPictureModalShowing2: false,
      isPictureModalShowing3: false,
      signURL: null,
      usersToSearch: [],
      photos: [],
      testphotos: [],
      photoZipFileName: '',
      filePrefixForEachFile: '',
      containerStats,
      inspectionType: null,
      ccicToSapFlag : true,
      filterConfirmed : false,
      sapNo: '',
      soItem: '',
      gateStatus:null,
      modalMessage: "",  
      isWarning: false,
      active: false,
      containerCopy: false,
      sortStatus: true,
      filter:"",
      notification: null,
      notifyActive: false,
      itemTotalCount: null,
      showUrgentDropDown: false,
      showEditDropDown: false,
      showDownloadDropDown: false,
      isLoading: false,
      loadpickeys: ['O1','O2','O3','O4','O5','P1','P2','P3','PC','PS'],
      mismatch: false,
      mismatchOnly: false,
      selectedLayout: null,
      userLayoutNameList: [],
      loaded_user_layout: [],
      loaded_default_allCols: [],
      layout_type: 'LOAD LIST',
      excludedColEles: ['usedHour','ownChassis','yard','mismatchBooking','photoCount', 
                       'inGatePhotoCount','outGatePhotoCount','containerNo','chassisNo',
                       'urgentContainer', 'driverPayConfirmSignImage', 'driverTaskConfirmSignImage',
                       'stcDriverTasksConfirmed','stcDriverTaskPayConfirmed','chassisplusPhotoCount'
                       ],
      loaded_recwin: [],
      loaded_recwin_id: [],
    }),

    components: {
      MoveCcicContainerForm,
      UpdateCcicContainerStatusForm,
      CcicPhotoForm,
      callingApiCenter,
      LoadListForm,
      UrgentContainerList,
      ReportLayoutForm,
    },


    watch: {
      getLoadList(val) {
        this.updateItems(val);
      },
      getLoadTotalCount(val) {
        this.getItemsCount(val); 
      },

      notifyActive(val) {
        if (val == false)
        {
          this.notification = null;
        }
      },
      // eslint-disable-next-line
      "searchRequest.teams"() {
         this.searchRequest.users = [];
      },
    },


    computed: {
      ...mapGetters([
        'getLoadList',
        'getLoadTotalCount',
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
      ]),
     
     
      filteredRows(){
        var items = this.items;
        if (this.mismatchOnly)
        {
           items = this.items.filter( it => it.mismatchBooking == true);
        }
        console.log(`items: ${JSON.stringify(items)}`);
        items = items.filter( it => this.loaded_recwin_id.includes(it.receivingWindows));
        //return this.items.filter(row => {
        return items.filter(row => {
          const term = this.filter.toUpperCase().trim();
          return this.includeNull(row.salesOffice).includes(term) ||
                  this.includeNull(row.loadKey).includes(term) ||
                  this.includeNull(row.loadStatus).includes(term) ||
                  this.includeNull(row.source).includes(term) ||
                  this.includeNull(row.containerNo).includes(term) ||
                  this.includeNull(row.chassisNo).includes(term) ||
                  this.includeNull(row.carrier).includes(term) ||
                  this.includeNull(row.yard).includes(term) ||
                  this.includeNull(row.locationNumber).includes(term) ||
                  this.includeNull(row.bookingNo).includes(term) ||
                  this.includeNull(row.emptyPulledBooking).includes(term) ||
                  this.includeNull(row.receivingWindows).includes(term) ||
                  this.includeNull(row.customerOrder).includes(term) ||
                  this.includeNull(row.gstOrder).includes(term) ||
                  this.includeNull(row.orderType).includes(term) ||
                  this.includeNull(row.bookingNo).includes(term) ||
                  this.includeNull(row.chassisVendor).includes(term) ||
                  this.includeNull(row.ctnrTypes).includes(term) ||
                  this.includeNull(row.grade).includes(term) ||
                  this.includeNull(row.specGrade).includes(term) ||
                  this.includeNull(row.newSeal).includes(term) ||
                  this.includeNull(row.scaleTicket).includes(term) ||
                  this.includeNull(row.billingNum).includes(term) ||
                  this.includeNull(row.outGate).includes(term) ||
                  this.includeNull(row.scac).includes(term);
        })
      },
      
      filteredUrgentRows(){
        return this.items.filter(row => {
          
        }) 
      },
           
      getSelectedItems() {
        return _(this.items).filter( it => this.loaded_recwin_id.includes(it.receivingWindows))
          .filter(it => it.selected);
      },

      getUnChangeItems() {
        return _(this.getSelectedItems)
          .filter(it => it.loadStatus == 'OU' );
      },
     
      canEdit() {
        return this.getSelectedItems.length === 1 ;
      },

      canChange() {
        return this.getSelectedItems.length === 1 && this.getUnChangeItems.length === 0;
      },

      canDelete() {
        return this.getSelectedItems.length === 1 &&
                this.getSelectedItems[0].loadStatus == 'EPT' ;
      },

      canVoid() {
        const canvoidItem = this.getSelectedItems.filter((it) => it.loadStatus !== "EPT" && it.loadStatus !== "LD" ) ;
        return canvoidItem.length === 0 && this.getSelectedItems.length !== 0;
      },

      canStatus() {
        return this.getSelectedItems.length !== 0 && this.getUnChangeItems.length == 0;
      },
     
      canSearchByTeam() {
        return this.getUserProfile.ccicRole === 'CCIC_ROLE_ADMIN' || this.getUserProfile.ccicRole === 'CCIC_ROLE_MANAGER';
      },

      getAllCcicTeamOptions() {
        return this.getMasterDataAsSelectOptionByGroup('CCIC_TEAM');
      },

      getCcicTeamSearchOptions() {
        const { ccicRole, ccicTeams } = this.getUserProfile;
        if (ccicRole === 'CCIC_ROLE_ADMIN') {
          return this.getAllCcicTeamOptions;
        }
        return this.getAllCcicTeamOptions.filter(it => _(ccicTeams)
          .contains(it.id));
      },

      getCcicUserSearchOptions() {
        const ccicUsers = this.usersToSearch;
        const selectedTeams = this.searchRequest.teams;
        if (selectedTeams.length === 0) {
          return ccicUsers;
        }
        return ccicUsers.filter(it => _.intersection(selectedTeams, it.ccicTeams).length > 0);
      },

      canSearchByUsers() {
        const { ccicRole } = this.getUserProfile;
        return ccicRole === 'CCIC_ROLE_ADMIN' || ccicRole === 'CCIC_ROLE_MANAGER';
      },
    },



    async mounted() {

      //get CCIC users
      const { ccicRole, ccicTeams } = this.getUserProfile;
      if (ccicRole !== 'CCIC_ROLE_INSPECTOR') {
        const allCcicUsers = await this.$store.dispatch(
          'getUsersByCategory',
          {
            category: 'G',
            dontFilterDisabled: true,
          },
        );
        //console.log(JSON.stringify(allCcicUsers));
        if (ccicRole === 'CCIC_ROLE_MANAGER') {
          this.usersToSearch = allCcicUsers.filter(it => _.intersection(it.ccicTeams, ccicTeams).length > 0);
        } else {
          this.usersToSearch = allCcicUsers;
        }
      }
      console.log("CCIC users: " + JSON.stringify(this.usersToSearch));
      // this.$el.querySelector('#expand-button').click();
      const cachedSearchRequest = this.$store.state.loadList.searchRequest;
      if (cachedSearchRequest) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      } ;
      this.searchRequest.moveInDate.startDate = moment().subtract(15,'days').startOf('d').toDate();
      this.searchRequest.moveInDate.endDate = moment().endOf('d').toDate();

      // this.searchRequest.salesOffice = this.getUserProfile.defaultSalesOffice;
      this.searchRequest.salesOffice = 'LGB' ;
      this.$el.querySelector('#searchTag').click();

      this.updateItems(this.getLoadList);
      this.getItemsCount(this.getLoadTotalCount);

      var p_loaded_recwin = this.getMasterDataByGroup('REC_WINDOW');
      console.log(`loaded recwin: ${JSON.stringify(p_loaded_recwin)}`);
      if (p_loaded_recwin.length > 0)
      {
        if (!this.getPermission.stc.view)
        {
            this.loaded_recwin = p_loaded_recwin.filter( it => it.tagName != 'STC');
        } else {
            this.loaded_recwin = p_loaded_recwin;
        }
        this.loaded_recwin.forEach((it) => {
          this.loaded_recwin_id.push(it.tagId); 
        });
        console.log(`inbound rec win1 : ${JSON.stringify(this.loaded_recwin)}`);

      } else {
        //this.inbound_recwin = api.post('/api/w/masterData', {groups: ['REC_WINDOW']}).filter( it => it.tagName != 'STC');
        //await api.post('/api/w/masterData', {groups: ['REC_WINDOW']})
        await newAPIPost('/api/w/masterData', {groups: ['REC_WINDOW']})
          .then((res) => {
              //p_loaded_recwin = res.filter(it => it.tagName != 'STC' && it.active);
              p_loaded_recwin = res.filter(it => it.active);
              if (!this.getPermission.stc.view)
              {
                  p_loaded_recwin = res.filter(it => it.tagName != 'STC' && it.active);
              }
              p_loaded_recwin.forEach((it) => {
                it.id = it.tagId;
                it.name = it.tagName;
                //if (this.getPermission.stc.view)
                //{
                  this.loaded_recwin.push(it);
                  this.loaded_recwin_id.push(it.tagId)
                //}
              })
              console.log(`inbound rec win: ${JSON.stringify(this.loaded_recwin)}`);
        });
      }

      this.doReloadLayout();


      // const { ccicRole, ccicTeams } = this.getUserProfile;
      // if (ccicRole !== 'CCIC_ROLE_INSPECTOR') {
      //   const allCcicUsers = await this.$store.dispatch(
      //     'getUsersByCategory',
      //     {
      //       category: 'L',
      //       dontFilterDisabled: true,
      //     },
      //   );
      //   console.log(JSON.stringify(allCcicUsers));
      //   if (ccicRole === 'CCIC_ROLE_MANAGER') {
      //     this.usersToSearch = allCcicUsers.filter(it => _.intersection(it.ccicTeams, ccicTeams).length > 0);
      //   } else {
      //     this.usersToSearch = allCcicUsers;
      //   }
      // }
    },


    methods: {

      handleOfficeChanged(id) {
        this.searchRequest.salesOffice = id;
      },

      handleCarrierChanged(id) {
        this.searchRequest.carrier = id;
      },

      handleWindowsChanged(id) {
        console.log(`rec window: ${id}`);
        this.searchRequest.receivingWindows = id;
      },

      getChassisDays(item){
        const usedDate = this.getChassisUsedDate(item);
        if (this.searchRequest.usedDay == null)
        {
          return true
        }
        else
        {
          
            return usedDate >= this.searchRequest.usedDay
        }
        

      },


        sortLocationDesc()
        {
          const sorted = sort(this.items).desc(r => this.getDisplay('STC_TERMINAL', r.pickUpLocation));
          this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
        },


        sortCompute(sortFiled)
        {
          const sorted = sort(this.items).desc(r => this.getChassisUsedDate(r));
          this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
        },


        sortHour(sortFiled)
        {
          const sorted = sort(this.items).desc(r => this.getChassisUsedHour(r));
          this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
        },

        sortFunction(sortFiled){
                const sorted = sort(this.items).asc(sortFiled);
                this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
          },


          sortSingleWay(sortFiled){
                sort(this.items).asc(sortFiled);
          },


          sortM(...args){
                sort(this.items).asc(args);
          },

        getChassisUsedHour(item){
          
          if (item.loadStatus == 'EPT'||item.loadStatus == 'LD'||item.loadStatus == 'ASN')
          {
            return moment().diff(moment(item.moveInDate), 'hours');;
          }
          else
          {
            return moment(item.chzEndDate).diff(moment(item.moveInDate), 'hours');
          }
        },
        
        getChassisUsedDate(item){
          if (item.chzEndDate == null)
          {
            //console.log("diff: " + this.getDateDiffCurr(item.chzStartDate));
            //return moment().diff(moment(item.chzStartDate)  , 'days') + 1
            return this.getDateDiffCurr(item.chzStartDate);
          }
          else
          {
            //console.log("diff1: " + this.getDateDiffDate(item.chzStartDate,item.chzEndDate));
            //return moment(item.chzEndDate).diff(moment(item.chzStartDate) , 'days') +1 
            return this.getDateDiffDate(item.chzStartDate,item.chzEndDate);
          }
        },

        getDateDiffCurr(date1) {
           //var p_date = []
           var p_datetime_el = [];
           const [month,day,year] = new Date().toLocaleDateString().split("/");
           const currDate = year + "-" + ((month.length == 1)? '0' + month : month) + "-" + ((day.length == 1)? '0' + day: day);
           if (date1 != null) {
              if (date1.toString().indexOf("T") > 0) {
                 p_datetime_el = date1.toString().split("T");
              } else { p_datetime_el[0] = date1; }
              //console.log("getdatediffcurr:date1: " + date1);
              //console.log("getdatediffcurr: " + p_datetime_el[0]);
              //console.log("diff: " + new Date(this.getCurrentTime(currDate)).getTime());
              //console.log("diff1: " + new Date(this.getCurrentTime(p_datetime_el[0])).getTime());
              const timeDiff = new Date(this.getCurrentTime(currDate)).getTime() - new Date(this.getCurrentTime(p_datetime_el[0])).getTime();
              return (Math.floor(timeDiff / (1000*60*60*24)) + 1);
           } else { return 0; }
      },

      getDateDiffDate(date1,date2) {
           var p_date1 = [];
           var p_date2 = [];
           //const [month,day,year] = new Date().toLocaleDateString().split("/");
           //const currDate = new Date(year + "-" + month + "-" + day);
           if (date1 != null && date2 != null) {
             if (date1.toString().indexOf("T") > 0) {
                p_date1 = date1.toString().split("T");
             } else {p_date1[0] = date1}
             if (date2.toString().indexOf("T") > 0) {
                p_date2 = date2.toString().split("T");
             } else {p_date2[0] = date2}
             //console.log("date1: " + p_date2[0] + "date2: " + p_date1[0]);
             const timeDiff = new Date(p_date2[0]).getTime() - new Date(p_date1[0]).getTime();
             return (Math.floor(timeDiff / (1000*60*60*24) + 1));
           } else {return 0;}
      },
      getCurrentTime(date) {
           var p_date_el = [];
           var p_datetime_el = [];
           var p_date = date;
           var retDate = date;
           //console.log("getcurrtime: date: " + date);
           if (date && date.toString().indexOf("T") > 0) {
              p_datetime_el = date.toString().split("T");
              p_date = p_datetime_el[0];
           }
           if (p_date && p_date.toString().indexOf("/") > 0) {
              p_date_el = p_date.toString().split("/");
              if (p_date_el.lenght == 3)
                 retDate = p_date_el[2] + "-" + p_date_el[0] + "-" + p_date_el[1];
           }     
           const currdatehour = new Date().getHours();
           const currdatemin = new Date().getMinutes();
           //console.log("hour: " + currdatehour + ", mins: " + currdatemin);
           //console.log("getcurrtime: retVal: " + retDate + "T" + currdatehour + ":" + currdatemin + ":00");               
           return retDate + "T" + currdatehour + ":" + currdatemin + ":00";
           
      },

        getChassisDaysInYard(item){
          if (item.outboundDate == null)
          {
            return moment().diff(moment(item.moveInDate), 'days')
          }
          else
          {
            return moment(item.outboundDate).diff(moment(item.moveInDate), 'days')
          }
        },



        includeNull(field){
            return field==null ? '' : field;
        },

        mouseOver: function(){
            this.active = true;
        },

        mouseLeave: function() {
          console.log(this.active);
              this.active = !this.active;
          },

        updateItems(itemsSource) {

          const iffsiuser = this.getUserProfile.companyId; 

          var items = JSON.parse(JSON.stringify(itemsSource));

          //console.log(JSON.stringify(itemsSource));

          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
            if (it.emptyPulledBooking != null && it.emptyPulledBooking != ''
                && it.bookingNo != null && it.bookingNo != '' 
                 && it.bookingNo != it.emptyPulledBooking)
            {
               it.mismatch = true;
            }
            else {
               it.mismatch = false;
            }
          });
          this.items = items.filter(it => this.getChassisDays(it));

          if (iffsiuser == '5000349')  // Filter out YI Load for FSI user
          {
            this.items = _(this.items).filter(it => it.orderType !== 'YI' ); 
            
            //console.log(iffsiuser);
          }


          this.sortSingleWay('loadStatus');
          if (this.notification != null)
          {
            this.notifyActive = true;
            
          }
        },

      getItemsCount(source) {
         console.log("source: " + JSON.stringify(source));
         this.itemTotalCount =  JSON.parse(JSON.stringify(source)); 
         console.log("itemtotalcount: " + this.itemTotalCount);
      },  

      doEdit(){
        this.showEditDropDown = false;
        const selectedItem = this.getSelectedItems[0];
        this.$refs.UpdateForm.openDialog(selectedItem);
      },

      doCopy(){
        this.showEditDropDown = false;
        const selectedItem = this.getSelectedItems[0];
        this.$refs.CopyForm.openDialog(selectedItem);
      },

      doStatus(){
        const selectedItem = this.getSelectedItems;
        this.$refs.StatusForm.openDialog(selectedItem);
      },

      doDelete(){
        this.showEditDropDown = false;
        const selectedItem = this.getSelectedItems[0];
        this.$refs.DeleteForm.openDialog(selectedItem);
      },

      async doSetUrgentCntr(){
        const selectedUrgentList = this.getSelectedItems;
        this.showDropDown = false;
        //console.log("selected: " + selectedUrgentList.length + ", selectedUrgentList: " + JSON.stringify(selectedUrgentList));
        if (selectedUrgentList && selectedUrgentList.length > 0) {
           //await api.post('/api/w/stc/updateUrgentContainer', {
           await newAPIPost('/api/w/stc/updateUrgentContainer', {
              urgentContainers: selectedUrgentList
           }).then( (result) => {
              this.$refs.UrgentContainerList.openDialog(selectedUrgentList);
              this.doSearch();
           })
        } else {
          alert("No item is selected!");
        }
      },

      doViewUrgentCntr(){
        this.$refs.ViewUrgentContainerList.openDialog();
        this.showDropDown = false;
      },

      // restore

      async doVoid(){

        this.$buefy.dialog.confirm({
                    title: 'Void Loads',
                    message: `Are you sure you want to <b>void</b> total of ${this.getSelectedItems.length} loads ? This action cannot be undone.`,
                    confirmText: 'Void Loads',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: async () => {
                       const salesOffice = this.searchRequest.salesOffice == null ? "LGB" : this.searchRequest.salesOffice.toUpperCase();
                        const requests = _(this.getSelectedItems).map(it => {
                            return {
                              user: it.user,
                              seqNo: it.seqNo,
                            
                            };
                          });

                        //await api.post('/api/w/gst/loadlist/create', {
                        await newAPIPost('/api/w/gst/loadlist/create', {
                            voids: requests,
                            action: 'VOIDS',
                            salesOffice: salesOffice
                          });
                          this.doSearch();
                    }
                })


      },
      // user defined layout start
      loadLayout()
      {
          if (this.selectedLayout != null && this.selectedLayout != "")
          {
              this.loadUserLayout(this.selectedLayout);
          }
      },
      
      async doReloadLayout()
      {
          this.loaded_default_allCols = [];
          await this.getLayoutNameList()
          .then(() => {
            this.loadUserLayout('',true, true)
            .then(() => {
                console.log(`user spec default layout: ${JSON.stringify(this.loaded_default_allCols)}`)
                if (this.loaded_default_allCols.length <= 0)
                {
                  this.loadUserLayout('',true, false)
                  .then(() => {
                      console.log(`general default layout: ${JSON.stringify(this.loaded_default_allCols)}`)
                      this.loaded_user_layout = this.loaded_default_allCols;
                  });
                } else {
                  this.loaded_user_layout = this.loaded_default_allCols;
                }
            });

          });
      },

      createLayout()
      {
          var update_layout = [];
          var process_report_module = 'LOADLIST';
          this.loadUserLayout('',true,false)
          .then(() => {
            update_layout = this.loaded_default_allCols;
            this.$refs.CreateLayoutForm.openDialog(process_report_module, this.selectedLayout, update_layout, this.loaded_default_allCols, false, false);
          });

      },

      updateLayout()
      {
          var update_layout = [];
          var process_report_module = 'LOADLIST';
          console.log(`selected layout: ${this.selectedLayout}`);
          this.loadUserLayout(this.selectedLayout)
          .then(() => {
            update_layout = this.loaded_user_layout;
            this.$refs.UpdateLayoutForm.openDialog(process_report_module, this.selectedLayout, update_layout, this.loaded_default_allCols, this.loaded_layout_userspec, this.loaded_layout_setdefault);
          });
      },

      docreate(id)
      {
        console.log(`return id: ${id}`);
        this.getLayoutNameList();
      },

      doupdate(id)
      {
        console.log(`return id: ${id}`);
      },

      async getLayoutNameList()
      {
          var p_layoutnames = [];
          this.layoutSearchRequest = getInitialLayoutSearchRequest();
          this.layoutSearchRequest.office = "FSI";
          this.layoutSearchRequest.reportModule = "LOADLIST";
          this.layoutSearchRequest.layoutnamelist = true;
          this.layoutSearchRequest.onlyActive = true;
          //await api.post('/api/w/layout/Search', this.layoutSearchRequest)
          await newAPIPost('/api/w/layout/Search', this.layoutSearchRequest)
          .then((val) => {
            if (val != null && val.layoutNameList != null && val.layoutNameList.length > 0)
            {
                val.layoutNameList.forEach((it) => { 
                    if (!p_layoutnames.includes(it))
                    {
                        p_layoutnames.push(it);
                    }
                });
                this.userLayoutNameList = p_layoutnames;
                console.log(`name list: ${JSON.stringify(this.userLayoutNameList)}`);
            }
          });
      },

      async loadUserLayout(loadlayoutname,loaddefaultallcols,userspecific)
      {
          var p_items = [];
          console.log(`loadlayoutname: ${loadlayoutname}`);
          this.layoutSearchRequest = getInitialLayoutSearchRequest();
          this.layoutSearchRequest.office = "FSI";
          if (userspecific)
          {
              this.layoutSearchRequest.userSpecific = userspecific;
          }
          if (loaddefaultallcols)
          {
              this.layoutSearchRequest.setDefault = true;
          }
          if (loadlayoutname != null && loadlayoutname != "")
          {
              this.layoutSearchRequest.layoutName = loadlayoutname;
          }
          this.layoutSearchRequest.reportModule = "LOADLIST";
          this.layoutSearchRequest.onlyActive = true;
          console.log(`search request: ${JSON.stringify(this.layoutSearchRequest)}`);
          //await api.post('/api/w/layout/Search', this.layoutSearchRequest)
          await newAPIPost('/api/w/layout/Search', this.layoutSearchRequest)
          .then((val) => {
            if (val != null && val.layoutInfoList != null && val.layoutInfoList.length > 0)
            {
                for (var i = 1; i < val.layoutInfoList.length + 1; i++)
                {
                    var p_index = i.toString();
                    var selectedrow = val.layoutInfoList.filter(it => it.colIndex == p_index);
                    if (selectedrow != null)
                    {
                        if (selectedrow.length > 0)
                        {
                          if (selectedrow[0].userSpecific != null)
                          {
                              this.loaded_layout_userspec = selectedrow[0].userSpecific;   
                          } else {
                              this.loaded_layout_userspec = false;
                          }
                          if (selectedrow[0].setDefault != null)
                          {
                              this.loaded_layout_setdefault = selectedrow[0].setDefault;
                          } else {
                              this.loaded_layout_setdefault = false
                          }
                          
                          
                          this.selectedLayout = selectedrow[0].layoutName;
                          console.log(`selected row: ${JSON.stringify(selectedrow[0])}`);
                          var p_row = reportLayoutElements();
                          p_row.orderIndex = i.toString();
                          p_row.colDataElement = selectedrow[0].colDataElement;
                          p_row.colHeaderText = selectedrow[0].colHeaderText;
                          p_row.colWidth = selectedrow[0].colWidth;
                          p_row.colDataType = selectedrow[0].colDataType;
                          if (!p_items.includes(p_row))
                          {
                              p_items.push(p_row);    
                          }
                        }
                    }   
                  }
              }
              if (!loaddefaultallcols)
              {
                this.loaded_user_layout = [];
                this.loaded_user_layout = p_items;
                console.log(`layout p items: ${JSON.stringify(p_items)} and row count: ${p_items.length}`);
                console.log(`layout user: ${JSON.stringify(this.loaded_user_layout)} and row count: ${this.loaded_user_layout.length}`);
              } else {
                this.loaded_default_allCols = [];
                this.loaded_default_allCols = p_items;
                console.log(`default layout p items: ${JSON.stringify(p_items)} and row count: ${p_items.length}`);
                console.log(`layout default all: ${JSON.stringify(this.loaded_default_allCols)} and row count: ${this.loaded_default_allCols.length}`);
              }
          });
      },

      handleLayoutChanged(id)
      {
          console.log(`change layout id: ${id}`);
          this.selectedLayout = id;
          //this.doReloadLayout();
      },


      // user defined layout end

      downloadUploadTempalte() {
        downloadExcel(
          [
            uploadCols,
            [
              'LGB',
              'CONTAINER00',
              'CHASSISNO00',
              'S',
              '185',
              '45G0',
              '2021-4-20',
              '11:11:11',
              'DRIVER',
              'OOLU',
              'YES',
              'CHASSISVENDOR',
              'EPT',
              'YARD',
              '300000',
              'poolContract',
            ],
          ],
          'LoadList',
          'ContainerUpload.xlsx',
        );
      },

      doDownloadExcel(){


        this.showDownloadDropDown = false;
        var row = [];
        var rows = [];
        
        this.items.forEach((item) => {
           this.loaded_user_layout.forEach((it) => {
              if (it.colDataType == 'DATE')
              {
                  row.push(dateFormat.date(item[it.colDataElement]));
              }
              if (it.colDataType == 'TIME')
              {
                  row.push(dateFormat.time(item[it.colDataElement]));
              }
              if (it.colDataElement == 'usedHour')
              {
                  row.push(this.getChassisUsedHour(item));
              }
              if (it.colDataElement == 'yard')
              {
                  row.push(item[it.colDataElement]);
              }
              if (it.colDataElement == 'mismatchBooking')
              {
                  if (item[it.colDataElement] == true)
                  {
                     row.push('X');
                  } else {
                     row.push('');
                  }
              }
              if (it.colDataElement == 'photoCount' || it.colDataElement == 'inGatePhotoCount' || it.colDataElement == 'outGatePhotoCount')
              {
                  if (item[it.colDataElement] > 0)
                  {
                     row.push(item[it.colDataElement] + ' photos');
                  } else {
                     row.push('');
                  }
              }
              if (it.colDataElement == 'containerNo' || it.colDataElement == 'chassisNo')
              {
                  row.push(item[it.colDataElement]);
              }
              if (it.colDataElement == 'ownChassis')
              {
                  if (item[it.colDataElement] == 'YES')
                  {
                      row.push('YES');
                  } else {
                      row.push('NO');
                  }
              }
              if (it.colDataElement == 'urgentContainer')
              {
                  if (item[it.colDataElement] == true)
                  {
                      row.push('X');
                  } else {
                      row.push('');
                  }
              }
              if ((it.colDataType != 'DATE' && it.colDataType != 'TIME') && !this.excludedColEles.includes(it.colDataElement))
              {
                  row.push(item[it.colDataElement]);
              } 
           })
           rows.push(row);
           row = [];

        });


       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'loadList.xls',
          1,
        );
        console.log(`layout export to excel: ${JSON.stringify(this.loaded_user_layout)}`);
        console.log(`layout length to excel: ${this.loaded_user_layout.length}`);
        request.headers = _(request.headers).take(this.loaded_user_layout.length);
        request.rows = _(rows);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },

      doDownloadChassisreport(){
        this.showDownloadDropDown = false;
       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Chassis Report.xls',
          1,
        );
        request.heads =  [
          ('Load Key') ,
          ('Chassis'),
          ('Container#'),
          ('Sales Office'),
          ('DO Customer'),
          ('Out Gate Date'),
          ('In Gate Date'),
          ('Street Turn'),
          ('Status'),
          ('Shiping line'),
          ('Chassis Used Day'),
            ] ,

          request.rows = _(this.filteredRows)
          .map(item => [
            item.loadKey,
            item.chassisNo,
            item.containerNo,
            item.salesOffice,
            item.custID,
            dateFormat.date(item.chzStartDate),
            dateFormat.date(item.chzEndDate),
            item.source,
            item.loadStatus,
            item.carrier,   
            this.getChassisUsedDate(item),         
           
          ]);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },

      toggleUpload() {
        this.$el.querySelector('#upload-load-list')
          .click();
      },

      handleUploadApplicationFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              if (!_.isEqual(headCols, uploadCols)) {
                window.alert('Not a valid format, please download most recent template!');
                return;
              }
              headCols.push('upload result');
              data.shift();
              //console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-load-list').value = '';
              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < uploadCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/gst/upload/loadlist',
                      {
                        salesOffice: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        containerNo: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        chassisNo: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        source: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        receivingWindows: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        ctnrType: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        moveInDate: dateFormat.getLocalDate(dateFormat.tryDateFromExcel(it[i++])),
                        moveInTime: moment('2021-04-01T' + it[i++]).format('HH:mm:ss'),
                        moveInBy: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        carrier: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        ownChassis: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        chassisVendor: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        loadStatus: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        yard: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        user: 'GST_SYSTEM',
                        locationNumber: it[i] == null ? it[i++] : it[i++].toString().toUpperCase(),
                        fallbackStart:  moment().subtract(1,'months').startOf('d').toDate(),
                        fallbackEnd: moment().endOf('d').toDate(),
                        username: this.getUserProfile.username,
                        poolContract: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                      },
                    )
                      .then((data) => {
                        it.push(data);
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'Load_List',
                    'LoadList-UploadResult.xlsx',
                  );
                });
            });
        }
      },

      toggleCreate() {
        this.$refs.CreateForm.openDialog();
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },

      doDropDown(catalog) {
          if (catalog == "edit")
          {
              this.showEditDropDown = !this.showEditDropDown;
          }
          if (catalog == "download")
          {
              this.showDownloadDropDown = !this.showDownloadDropDown;
          }
          if (catalog == "urgent")
          {
              this.showUrgentDropDown = !this.showUrgentDropDown;
          }
      }, 



      async onRefresh(item, mode){
        this.notification =  null;
        
        switch(mode) {
            case 'create':
              this.notification = `Item with load ID ${item} has been created!`;
              break;
            case 'copy':
              this.notification = `Item with load ID ${item} has been created!`;
              break;

            case 'update':
              this.notification = `Item with load ID ${item} has been udpated!`;
              break;
            case 'delete':
              this.notification = `Item with load ID ${item} has been deleted!`;
              break;
            

          }

          this.doSearch();


        
      },


      doSearch() {
         this.$store.commit('clearApiError');
         
        const {
          users,
          teams,
          moveInDate,
          createDate,
          isCCICSearch,
          salesOffice,
          //receivingWindow,
        } = this.searchRequest;

        const s = "2018-5-31";
        // console.log('test');
        // console.log(dateFormat.tryDateFromExcel(s));


        //  this.modalMessage = "";
        // if (!moveInDate.startDate) {
        //   this.modalMessage = "Move In DATE MUST TO BE FILLED"
        //   this.isWarning = true
        //   return;
        // }

        if ((moveInDate.startDate == null || moveInDate.startDate === '') && !isCCICSearch)
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Move in date is required for Search`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }

      //console.log("create date start: " + createDate.startDate);
      //console.log("create date end: " + createDate.endDate);
      //console.log("iscciccheck: " + isCCICSearch);

      if (((createDate.startDate == null || createDate.startDate === '') && (createDate.endDate == null || createDate.endDate === '')) && isCCICSearch)
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Create date is required for Search with For CCIC is checked`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }

      const { ccicRole } = this.getUserProfile;
      this.searchRequest.usersInTeam = [];
      if (ccicRole === "CCIC_ROLE_INSPECTOR") {
          this.searchRequest.users = [this.getUserProfile.username];
      } else if (users.length === 0 && teams.length > 0) {
          this.searchRequest.usersInTeam = this.usersToSearch
            .filter(u => _.intersection(teams, u.ccicTeams).length > 0)
            .map(it => it.id);
      } else if (users.length === 0 && teams.length === 0) {
          if (ccicRole === "CCIC_ROLE_MANAGER") {
            this.searchRequest.usersInTeam = this.usersToSearch.map(it => it.id);
          }
      }
      if (this.searchRequest.users.length === 0 && this.searchRequest.usersInTeam && this.searchRequest.usersInTeam.length > 0) {
            this.searchRequest.users = this.searchRequest.usersInTeam;
      }

      this.searchRequest.containerNo = this.searchRequest.containerNo == null ? this.searchRequest.containerNo : this.searchRequest.containerNo.toUpperCase().trim();
      this.searchRequest.chassisNo = this.searchRequest.chassisNo == null ? this.searchRequest.chassisNo : this.searchRequest.chassisNo.toUpperCase().trim();
      this.searchRequest.salesOffice = this.searchRequest.salesOffice == null ? "LGB" : this.searchRequest.salesOffice.toUpperCase();
      this.$store.dispatch('loadContainerList', this.searchRequest);
      this.active = false;
      },

      clearSearch() {
         
          _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
         //_(this.$el.querySelectorAll('.searchPanel'))
          .each((it) => {
            it.click();
          });
          this.$nextTick(() => {
            this.searchRequest = getInitSearch();
            this.searchRequest.moveInDate.startDate = moment().subtract(1,'months').startOf('d').toDate();
            this.searchRequest.moveInDate.endDate = moment().endOf('d').toDate();
            this.searchRequest.salesOffice = this.getUserProfile.defaultSalesOffice;
          });
          
      },

      overPeriod(item) {
          //var usedday = this.getChassisUsedDate(item);
          var usedday = item.ctnrUsedDay;
          //console.log("overperiod: " + usedday);
          return (usedday >= 5 && (item.chzEndDate == null || item.chzEndDate == ""));
      },

      getDisplay(group , tagId ) {
        if (!tagId) {
          return "";
        }
        return this.getMasterDataName(group, tagId) || this.tagId;
      },




      toggleContainerCopy(element){
          this.containerCopy = true;
          setTimeout(() => {  this.containerCopy = false; }, 2000);
          var el = document.createElement('textarea');
          el.value = element;
          el.setAttribute('readonly', '');
          el.style = {position: 'absolute', left: '-9999px'};
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
      },


  async toggleItemPhoto(item, status) {
        this.gateStatus = status;
        //this.photos = item
        // this.photoZipFileName = `${item.application.bookingNo}_${item.application.poNo}_${item.containerNo}.zip`;
        // this.filePrefixForEachFile = `${item.containerNo}-`;
        //this.photoZipFileName = `${item.application.bookingNo}_${item.application.poNo}_${item.containerNo}.zip`;
        // this.filePrefixForEachFile = `${item.containerNo}-`;
        if (status == "IN GATE PHOTO" || status == "OUT GATE PHOTO")
        {
           this.isPictureModalShowing = true;
           //await api.post("/api/w/ccic/photo/getInOutGate", {containerSeqNo:item.seqNo}).then(
           await newAPIPost("/api/w/ccic/photo/getInOutGate", {containerSeqNo:item.seqNo}).then(
             (val) => {
                if (status == "IN GATE PHOTO") {
                   this.photos = val.ingatephoto
                } else if (status == "OUT GATE PHOTO") {
                   console.log("photolist: " + JSON.stringify(val.outgatephoto));
                   this.photos = val.outgatephoto
                }
           })
        }
        else if (status == "LOADING PHOTO") 
        {
           this.isPictureModalShowing2 = true;
           this.isLoading = true;
           //this.photos = (await api.post('/api/w/ccic/photo/get', { containerSeqNo: item.seqNo, outboundLoadingPic: true }))
           this.photos = (await newAPIPost('/api/w/ccic/photo/get', { containerSeqNo: item.seqNo, outboundLoadingPic: true }))
               .filter(it => this.loadpickeys.includes(it.photoKey));
           if (item.bookingNo != null)
             this.photoZipFileName = `${item.seqNo}_${item.bookingNo}_${item.containerNo}.zip`;
           else
             this.photoZipFileName = `${item.seqNo}_${item.containerNo}.zip`;
           this.filePrefixForEachFile = `${item.containerNo}-`;
           console.log(this.photos)    
        }
        else if (status == "CHASSIS PLUS PHOTO")
        {
           this.isPictureModalShowing = true;
           //await api.post("/api/w/ccic/photo/getInOutGate", {containerSeqNo:item.seqNo}).then(
           var p_seqno = item.seqNo;
           if (item.outGate != null && item.outGate != '')
           {
              p_seqno = item.outGate
           }
           await newAPIPost("/api/w/ccic/photo/get", {containerSeqNo:p_seqno}).then(
             (val) => {
                 console.log(`chassis plus photo: val - ${JSON.stringify(val)}`);
                 var p_photos = [];
                 val.forEach((it) => {
                    console.log(`the substring of the photokey: ${it.photoKey} ${it.photoKey.substring(2,4)}`);
                    if (it.photoKey.substring(2,4) == 'CP')
                    {
                       p_photos.push(it);
                    }
                 });
                 //console.log(`show only CP pics: ${JSON.stringify(val.filter( (it) => { it.photoKey.substring(2,4) == 'CP'})`);
                 //console.log(`show only pics: ${ JSON.stringify(val.filter((it) => {it.photoKey.substring(2,4) == 'CP'})) }`); 
                 this.photos = p_photos;
                 //this.photos = val.filter( (it) => { it.photoKey.substring(2,4) == "CP"});
                 this.photoZipFileName = `${item.seqNo}_${item.containerNo}.zip`;
                 this.filePrefixForEachFile = `${item.containerNo}-`;
                 console.log(`chassis plus photos in load list: ${JSON.stringify(this.photos)}`);
              });
        }
        else if (status == 'SIGN CONFIRM PHOTO' || status == 'SIGN CONFIRM PAY PHOTO')
        {
           this.isPictureModalShowing3 = true;
           if (status == 'SIGN CONFIRM PHOTO')
           {
              this.signURL = item.driverTaskConfirmSignImage;
           } else {
              this.signURL = item.driverPayConfirmSignImage;
           }
        }
      },

      getPhotoName(photo, type) {
        if (type == "LOAD") {
           const photoName = decodeURI(photo.photoUrl.replace(/.*\//g, ""));
           return `${this.filePrefixForEachFile || ''}${photoName}`;
        } else if (type == "INOUT") {
                 return 'Photo Name'
        }
      },

      doDownload() {
        this.downloading = true;
        const zipFileName = this.zipFileName || 'pictures.zip';
        const promises = _(this.testphotos)
          .map((photo) => {
            const a = document.createElement('a');
            a.href = photo.photoUrl;

            const req = {
              method: 'GET',
              mode: 'no-cors',
              cache: 'default',
            };

            const pathName = a.pathname;
            console.log(pathName);
            return fetch(pathName, req)
              .then(response => ({
                response,
                photo,
              }));
          });


        Promise.all(promises)
          .then((results) => {
            this.downloading = false;
            console.log(`aa`, results);
            const zip = new JSZip();
            _.chain(results)
              .groupBy(it => it.photo.containerNo)
              .each((values, k) => {
                console.log(values[0].photo.bookingNo)
                const target = (`${k}` !== `null`) ? zip.folder(k) : zip;
                _(values)
                  .each(({ response,photo }) => {
                    const res = response;
                    let filename = photo.containerNo + "-" + decodeURI(res.url.replace(/.*\//g, ""));
                    if (!filename.endsWith('png') || !filename.endsWith('jpg')) {
                      filename += '.png';
                    }
                    console.log(`filename=${filename}`);
                    const blob = res.blob();
                    target.file(filename, blob, { binary: true });
                  });
              });

            zip.generateAsync({ type: "blob" })
              .then((blob) => {
                const a = $("<a style='display: none;'/>");
                const url = window.URL.createObjectURL(blob);
                a.attr("href", url);
                a.attr("download", zipFileName);
                $("body")
                  .append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
                this.isdownloadzip = false;
              });
          })
          .catch((e) => {
            console.error(e);
            this.downloading = false;
            this.isdownloadzip = false;
          });
    },

    // ponytail: run worker over items, max `limit` concurrent, each retried up to `retries` times.
    // Firing hundreds/thousands of fetch (or API) calls at once triggers Chrome ERR_INSUFFICIENT_RESOURCES
    // and silently drops whole containers; a bounded pool downloads everything, just slower.
    async runPool(items, worker, limit, retries) {
      limit = limit || 6;
      retries = (retries == null) ? 2 : retries;
      const out = new Array(items.length);
      let next = 0;
      const lane = async () => {
        while (next < items.length) {
          const i = next++;
          for (let attempt = 0; ; attempt++) {
            try {
              out[i] = { item: items[i], ok: true, value: await worker(items[i], i) };
              break;
            } catch (e) {
              if (attempt >= retries) { out[i] = { item: items[i], ok: false, error: e }; break; }
            }
          }
        }
      };
      const lanes = [];
      const width = Math.min(limit, items.length);
      for (let n = 0; n < width; n++) lanes.push(lane());
      await Promise.all(lanes);
      return out;
    },

    async doDownload() {
        this.downloading = true;
        const zipFileName = this.zipFileName || 'pictures.zip';
        const zip = new JSZip();
        const seen = {};
        const failed = [];

        // bounded concurrency: never more than 8 image fetches in flight -> no ERR_INSUFFICIENT_RESOURCES
        const results = await this.runPool(this.testphotos, async (photo) => {
          const a = document.createElement('a');
          a.href = photo.photoUrl;
          const res = await fetch(a.pathname, { method: 'GET', mode: 'no-cors', cache: 'default' });
          return { res, photo };
        }, 8, 2);

        results.forEach((r) => {
          if (!r.ok) { failed.push(r.item.containerNo); return; }   // one failed fetch no longer aborts the whole zip
          const { res, photo } = r.value;
          const k = photo.containerNo;
          const target = (`${k}` !== `null`) ? zip.folder(k) : zip;
          // name from photoUrl basename so the zip entry matches the "File Name" shown in the UI
          // (res.url is "" under no-cors, so derive from the request URL we already have)
          const base = decodeURI((photo.photoUrl || '').replace(/.*\//g, "")) || photo.photoKey || 'photo';
          let filename = photo.containerNo + "-" + base;
          if (!/\.(png|jpe?g)$/i.test(filename)) filename += '.png';
          const nameKey = k + '/' + filename;
          seen[nameKey] = (seen[nameKey] || 0) + 1;
          if (seen[nameKey] > 1) filename = filename.replace(/(\.[^.]+)$/, `-${seen[nameKey]}$1`);
          target.file(filename, res.blob(), { binary: true });
        });

        const blob = await zip.generateAsync({ type: "blob" });
        const a = $("<a style='display: none;'/>");
        const url = window.URL.createObjectURL(blob);
        a.attr("href", url);
        a.attr("download", zipFileName);
        $("body").append(a);
        a[0].click();
        window.URL.revokeObjectURL(url);
        a.remove();
        this.downloading = false;
        this.isdownloadzip = false;

        if (failed.length) {
          const uniq = Array.from(new Set(failed));
          window.alert(`以下 ${uniq.length} 柜有照片下载失败，请重新下载：\n${uniq.join(', ')}`);
        }
      },

      async doPhotos(){
        this.isdownloadzip = true;
        const KEEP = ['P1', 'P2', 'P3', 'PC', 'PS'];
        const photos = [];

        // bounded concurrency for the per-container photo-list calls too
        const results = await this.runPool(this.items, async (it) => {
          const result = await newAPIPost('/api/w/ccic/photo/get', { containerSeqNo: it.seqNo });
          (result || []).forEach((it2) => {
            if (KEEP.indexOf(it2.photoKey) !== -1) {
              it2.containerNo = it.containerNo;
              it2.bookingNo = it.bookingNo;
              photos.push(it2);
            }
          });
        }, 5, 2);

        this.testphotos = photos;

        const failed = results.filter(r => !r.ok).map(r => r.item.containerNo);
        const withPhotos = new Set(photos.map(p => p.containerNo)).size;
        window.alert(`共 ${this.items.length} 柜：${withPhotos} 柜有装柜照片（将下载 ${withPhotos} 个文件夹），${this.items.length - withPhotos - failed.length} 柜无装柜照片，${failed.length} 柜读取失败`);
        if (failed.length) {
          window.alert(`以下 ${failed.length} 柜读取照片清单失败，请重新下载：\n${failed.join(', ')}`);
        }
        this.doDownload();
      },

    },
  };
</script>
